import { render, staticRenderFns } from "./AccountBalance.vue?vue&type=template&id=6df93162&scoped=true&"
import script from "./AccountBalance.vue?vue&type=script&lang=js&"
export * from "./AccountBalance.vue?vue&type=script&lang=js&"
import style0 from "./AccountBalance.vue?vue&type=style&index=0&id=6df93162&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df93162",
  null
  
)

export default component.exports